export default "__VITE_ASSET__8f326ba3__"